import find from "lodash/find";
import filter from "lodash/filter";
import get from "lodash/get";
import toString from "lodash/toString";
import size from "lodash/size";
import map from "lodash/map";
import toLower from "lodash/toLower";
import dayjs from "dayjs";
import { DOCUMENT_TYPES } from "./constants";
import { includes } from "lodash";

export const getOwners = (contacts) =>
  filter(contacts, (c) => get(c, ["baseContactType", "id"]) === 3);

export const getContact = (contacts, contactId) =>
  find(contacts, (c) => toString(get(c, "contactId")) === contactId);

export const getVariablesFromTemplate = (template) => {
  const regex = /\{\{(.+?)\}\}/g;
  const vars = [];
  let match;
  while ((match = regex.exec(template)) !== null) {
    vars.push(match[1]);
  }
  return vars;
};

export const getAllData = async (fn, dataPath) => {
  let values = [];

  let offset = 0;
  let totalCount = -1;
  while (totalCount < 0 || totalCount > offset) {
    const data = await fn(offset);
    if (totalCount < 0) {
      totalCount = get(data, "totalCount", 0);
    }
    const currentData = get(data, dataPath, []);
    values = [...values, ...currentData];
    offset = size(values);
  }
  return values;
};

export const getTokenFromLS = () => localStorage.getItem("token");

export const getHeaders = (headers = {}) => ({
  Authorization: `Bearer ${getTokenFromLS()}`,
  ...headers,
});

export const base64ToObjectURL = (base64) => {
  const matches = base64.match(/^data:(.+);base64,(.+)$/);
  const mime = matches ? matches[1] : "";
  const b64Data = matches ? matches[2] : base64;

  const byteCharacters = atob(b64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mime });
  return URL.createObjectURL(blob);
};

export const extractInformationFromFile = (file) => {
  const sectionsWithUnderscore = file.name.split("_");
  const sectionsWithDash = file.name.split("-");

  const sections =
    size(sectionsWithUnderscore) > size(sectionsWithDash)
      ? sectionsWithUnderscore
      : sectionsWithDash;
  if (sections.length === 0) return {};

  const dateStr = get(sections, 0);
  const effectiveDate = dayjs(dateStr, "YYMMDD");
  const effectiveDateStr = effectiveDate.isValid()
    ? effectiveDate.format("DD-MM-YYYY")
    : null;

  const documentTypeName = get(sections, 1);
  const documentTypes = getStaticDocTypes();
  const currentDocType = find(documentTypes, (docType) =>
    includes(toLower(docType.name), toLower(documentTypeName))
  );

  const dotIndex = file.name.lastIndexOf(".");
  const nameWithoutExtension = file.name.substring(0, dotIndex);

  return {
    name: nameWithoutExtension,
    effectiveDate: effectiveDate,
    effectiveDateStr: effectiveDateStr,
    documentType: !!currentDocType ? currentDocType.id : null,
    documentTypeName: !!currentDocType ? currentDocType.name : "",
    sizeMo: (file.size / (1024 * 1024)).toFixed(2),
    extension: file.name.substring(dotIndex),
  };
};

export const getExtensionFromFilename = (filename) => {
  const dotIndex = filename.lastIndexOf(".");
  if (dotIndex === -1) return "";
  return filename.substring(dotIndex + 1).toLowerCase();
};

export const getRelatedDocTypesExclude = (ids = []) => {
  return map(
    filter(DOCUMENT_TYPES, (docType) => !ids.includes(docType.id)),
    (doc) => doc.id
  );
};

export const getDocTypesWithTemplate = (isActive = true) =>
  filter(DOCUMENT_TYPES, (doc) => doc.hasTemplate && doc.isActive === isActive);

export const getStaticDocTypes = (isActive = true) =>
  filter(
    DOCUMENT_TYPES,
    (doc) => !doc.hasTemplate && doc.isActive === isActive
  );

export const getDefaultOffices = (offices) =>
  filter(
    offices,
    ({ name }) =>
      includes(toLower(name), "neuf") && !includes(toLower(name), "lux neuf")
  );
